import { gql } from '@apollo/client';

export interface Input {
  staffId: string;
  organizationId: number;
}

export interface Data {
  id: string;
}

export const MUTATION = gql`
  mutation DeleteStaff($staffId: ID!, $organizationId: ID!) {
    removeStaff(filter: { organizationId: $organizationId, staffId: $staffId }) {
      id
    }
  }
`;
